<template>
  <div>
    <v-btn
      :class="!$vuetify.dark ? 'secondary' : ''"
      :color="$vuetify.dark ? 'secondary' : ''"
      :outline="$vuetify.dark"
      flat
      @click.stop="dialog = true"
    >
      <span class="ml-2 text-capitalize">Trigger a new execution</span>
    </v-btn>
    <v-dialog v-model="dialog" max-width="80%" persistent>
      <v-card>
        <v-toolbar class="body-2 beez-bold" dense flat
          >Trigger Bot based on the current inputs
          <v-spacer />
          <v-btn flat icon @click="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-flex fluid>
            <v-layout class="pa-2" row>
              <v-flex grow>
                <v-card>
                  <v-toolbar card class="body-2 beez-bold" dense>
                    Trigger Bot execution with modified Input
                    <v-spacer></v-spacer>
                    <v-btn
                      class="text-capitalize"
                      outline
                      flat
                      @click.stop="jsonEditorView = !jsonEditorView"
                    >
                      {{ jsonEditorView ? 'Form View' : 'JSON View' }}
                    </v-btn>
                  </v-toolbar>
                  <v-card-text>
                    <v-flex v-if="jsonEditorView">
                      <v-flex xs12>
                        <div>
                          <v-icon class="warning--text">info</v-icon>
                          <strong class="pl-2"
                            >Update the input directly as JSON
                          </strong>
                        </div>
                        <v-jsoneditor
                          key="jsonEditor"
                          v-model="botInput"
                          :options="jsonOptions"
                          :plus="true"
                          height="400px"
                        >
                        </v-jsoneditor>
                      </v-flex>
                    </v-flex>
                    <v-flex v-else xs12>
                      <form-generator
                        :key="execution.hexId + 'update-props-schema'"
                        :readonly="false"
                        :schema="botInput"
                        :submit-loader="submitLoader"
                        @submit="handleTrigger"
                      />
                    </v-flex>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import FormGenerator from '@/components/common/form-generator/FormGenerator'

export default {
  components: { FormGenerator },
  name: 'ExecuteBotBasedOnHistory',
  data: function() {
    return {
      botInput: [],
      dialog: false,
      jsonEditorView: false,
      jsonOptions: { mode: 'code' }
    }
  },
  props: {
    execution: Object,
    submitLoader: {
      default: false,
      type: Boolean
    }
  },
  mounted() {
    this.botInput = [...this.execution.schemaProposedInput]
  },
  methods: {
    setInputs: function(executionTrigger, inputs) {
      executionTrigger.botInputs = {}
      let inputArray = Object.keys(inputs)
      for (let i = 0; i < inputArray.length; i++) {
        executionTrigger.botInputs[inputArray[i]] = {
          value: inputs[[inputArray[i]]],
          type: 'STRING',
          objectTypeName: 'java.lang.String',
          flowVariable: false
        }
      }
    },
    handleTrigger: function(inputs) {
      let executionTrigger = {}
      executionTrigger.externalId = this.execution.hexId
      this.setInputs(executionTrigger, inputs)
      this.$emit('trigger', executionTrigger)
      this.dialog = false
    }
  }
}
</script>

<style scoped></style>
